class ProductPriceHistoryModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'productId'
		'productVariantId'
		'priceRegions',
		'ProductRepository'

	initialize: ->
		@from = moment().startOf('month').unix()
		@to = moment().unix()

		@currentPriceRegionId = @priceRegions[0].id
		@priceRegionMap = _.indexBy(@priceRegions, 'id')
		@currentPriceRegionCurrency = @priceRegionMap[@currentPriceRegionId].currency

		@search()

	search: ->
		@ProductRepository
			.getPriceHistory(
				@productId,
				@productVariantId,
				@currentPriceRegionId,
				@from,
				@to,
			)
			.then (response) =>
				@priceHistory = response[@currentPriceRegionId]
				@priceHistoryExists = !_.isEmpty(@priceHistory)
				@currentPriceRegionCurrency = @priceRegionMap[@currentPriceRegionId].currency
